export const store = {
  debug: true,
  state: {
    editMode: false,
    dailyTarget: 4,
    pomodoro: {
      focusDuration: Number(process.env.VUE_APP_POMODORO_FOCUS_DURATION),
      shortBreakDuration: Number(process.env.VUE_APP_POMODORO_SHORT_BREAK_DURATION),
      longBreakDuration: Number(process.env.VUE_APP_POMODORO_LONG_BREAK_DURATION),
    },
    intervals: []
  },
  turnOnEditMode () {
    this.state.editMode = true
  },
  turnOffEditMode () {
    this.state.editMode = false
  },
  setFocusDuration (seconds) {
    this.state.pomodoro.focusDuration = seconds
  },
  setShortBreakDuration (seconds) {
    this.state.pomodoro.shortBreakDuration = seconds
  },
  setLongBreakDuration (seconds) {
    this.state.pomodoro.longBreakDuration = seconds
  },
  setDailyTarget (hours) {
    this.state.dailyTarget = hours
  },
  addInterval (name, seconds) {
    this.state.intervals.push({name: name, seconds: seconds});
  },
  clearIntervals () {
    this.state.intervals = [];
  }
}
